import { render } from "./pestel_main.vue?vue&type=template&id=5d35417a&scoped=true"
import script from "./pestel_main.vue?vue&type=script&lang=js"
export * from "./pestel_main.vue?vue&type=script&lang=js"

import "./pestel_main.vue?vue&type=style&index=0&id=5d35417a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d35417a"]])

export default __exports__